import React from "react";

import { RobotoButton } from "@/shared/components";
import { ClientViewingContext } from "@/shared/domain/agentThread/AgentThreadRecord.ts";

import styles from "./NewAgentThreadExamples.module.css";

interface NewAgentThreadExampleProps {
  question: string;
  onExampleClick: (question: string) => void;
}

interface NewAgentThreadExamplesProps {
  onExampleClick: (question: string) => void;
  context: ClientViewingContext;
}

const NewAgentThreadExample = ({
  onExampleClick,
  question,
}: NewAgentThreadExampleProps) => {
  return (
    <RobotoButton
      variant="outlined"
      size="small"
      onClick={() => onExampleClick(question)}
      className={styles.exampleButton}
      eventName={"ExampleAgentThreadMessageClicked"}
    >
      {question}
    </RobotoButton>
  );
};

const NewAgentThreadExamples = ({
  onExampleClick,
  context,
}: NewAgentThreadExamplesProps) => {
  const questions = React.useMemo(() => {
    if (context.dataset_ids.length > 0) {
      return [
        "Briefly summarize this dataset",
        "Link me to interesting visualizations",
        "What topics are available?",
        "Are there events in this dataset?",
      ];
    }

    if (context.file_ids.length > 0) {
      return [
        "Briefly summarize this file",
        "What topics are available?",
        "Open a plot for me",
      ];
    }

    return [
      "What datasets were created today?",
      "What are some tags I can search for?",
    ];
  }, [context]);

  return (
    <div className={styles.mainContainer}>
      {questions.map((question, index) => (
        <NewAgentThreadExample
          key={index}
          onExampleClick={onExampleClick}
          question={question}
        />
      ))}
    </div>
  );
};

export { NewAgentThreadExamples };
